inputs-typeahead-multiple
  div(class="form-group row { error: opts.errors }")
    label.col-md-4.col-form-label
      | {opts.label}
      span.text-danger(if="{ opts.required }") &nbsp;*
    .col-md-8
      .row
        .col-12.col-md-6(each="{opts.items}")
          .item.form-group.clearfix
            .text.align-middle { text }
            span.align-middle.btn.btn-danger.btn-outline-danger.btn-sm.btn-close.icon-btn(onClick="{parent.onClickRemoveBtn}")
              i.feather.icon-x
            input(type="hidden" name="{parent.opts.name}" value="{id}")
      inputs-without-label-typeahead(tag-scope="{ this.tagScope }.typeahead" onSelect="{ this.onSelectItem }")
  script(type="typescript").
    this.mixin('inputs.typeahead-multiple');
  style(scoped).
    .item {
      position: relative;
      padding: 10px 15px;
      background: rgba(68, 138, 255, .1);
    }
    .text {
      display: inline-block;
      padding-top: calc(0.375rem + 1px);
      padding-bottom: calc(0.375rem + 1px);
    }
    .btn-close {
      float: right;
    }
